import React, { useState, useEffect } from "react";

import banner from "../assets/facilitr-banner.png";

const Home = () => {
  const [content, setContent] = useState("");

  useEffect(() => {}, []);

  return (
    <div className="container">
      <header className="jumbotron">
        <h3>Welcome to Facilitr Home</h3>
        <img src={banner} className="banner" alt="facilitr-banner" />
      </header>
    </div>
  );
};

export default Home;
